import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AppLoad } from "../../../core/AppLoad";
import { useHistory, useParams } from "react-router-dom";
import { AppConfig } from "../../../app-state";
import { NavbarBackHome } from "../../common/header-and-footer/NavbarBackHome";
import { FormGroup } from "../../../core/Form";
import { SubmitButton } from "../../../core/SubmitButton";
export const PasswordReset = (props) => {
    // const { state, dispatch } = useContext(AppStateContext);
    const [loadState, setLoadState] = useState('idle');
    // const [loginResponse, updateLoginResponse] = useState(null);
    // const { register, handleSubmit, errors, setValue } = useForm<ILoginFormData>();
    const { register, handleSubmit, errors, setValue } = useForm();
    const { urlHash } = useParams();
    let history = useHistory();
    const onSubmit = (data) => {
        setLoadState('submitting');
        data.hash = urlHash;
        AppLoad(AppConfig.APIUrl + 'public/auth/PasswordReset', data).then((Response) => {
            if (Response.status == 'ok') {
                setLoadState('saved');
                history.push('/cs/proces/heslo-nastaveno');
            }
            else if (Response.status == 'error') {
                alert(Response.message);
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NavbarBackHome, null),
        React.createElement("div", { className: "process-master-form" },
            React.createElement("div", { className: "" },
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), className: "form" },
                    React.createElement("h1", { className: "page-header" }, "Nastaven\u00ED nov\u00E9ho hesla"),
                    React.createElement("fieldset", { disabled: loadState == 'submitting' },
                        React.createElement(FormGroup, { id: "heslo", label: "Heslo", error: errors.password && 'Prosím vyplňte' },
                            React.createElement("input", { autoComplete: "off", className: "textfield", id: "heslo", ref: register({ required: true }), name: "password", type: "password" })),
                        React.createElement(FormGroup, { id: "hesloZnovu", cssWrapper: "mb-32", label: "Heslo znovu", error: errors.passwordRepeat && 'Prosím vyplňte' },
                            React.createElement("input", { autoComplete: "off", className: "textfield", id: "hesloZnovu", ref: register({ required: true }), name: "passwordRepeat", type: "password" }))),
                    React.createElement(SubmitButton, { label: "Pokra\u010Dovat", loadState: loadState }))))));
};
